import { useState, useEffect } from "react";
import "../index.css";

const photo = "/nira.jpg";

export default function Landing() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setVisible(true), 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="bio-wrapper">
            <div className={`bio-card ${visible ? "visible" : ""}`}>
                <div className="photo-wrap">
                    <img src={photo} alt="Nira Patel" />
                </div>

                <div className="text-side">
                    <div className="title-block">
                        <h1 className="main-title">Nira Patel</h1>
                        <p className="name-tag">PRODUCT MANAGER & UX DESIGNER</p>
                    </div>

                    <p className="bio-text">
                        Hi! I'm a Computer Science student at Oregon State University specializing in Human-Computer Interaction and UX Research, 
                        currently working as <strong>Junior Product Manager</strong> at <a href="https://www.digs.com" target="_blank" rel="noreferrer" className="inline-link"><strong>Digs</strong></a>. With experience spanning <strong>user 
                        research, product strategy, and technical project management</strong>, I'm passionate about building inclusive, user-centered
                        technology. I am also the <strong>Co-Founder</strong> and <strong>Vice President</strong> of the <a href="https://pmc-website-nu.vercel.app/" target="_blank" rel="noreferrer" className="inline-link"><strong>
                        Product Management Club</strong></a> at OSU.
                    </p>
                </div>
            </div>
            <a
                href="https://www.linkedin.com/in/nirapatelm"
                target="_blank"
                rel="noreferrer"
                className="linkedin-link"
            >
                LinkedIn
            </a>
        </div>
    );
}